import script from "./ercCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ercCard.vue?vue&type=script&setup=true&lang=js"

import "./ercCard.vue?vue&type=style&index=0&id=2eecb54e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eecb54e"]])

export default __exports__